/**
 * Feature flags — frontend-only on/off switches that hide functionality
 * without removing the underlying code, routes, or data.
 *
 * The point of these flags is to let us pause a feature surface across
 * the whole UI from one place, while keeping backend collections, S3
 * paths, and stored data intact. Re-enabling is one boolean flip.
 *
 * History:
 *   - 2026-05-07: PHOTOS_ENABLED disabled. Photo uploads, the /photos
 *     page, the dashboard "Camera"/photo prompts, the Timeline historical
 *     photo overlay, and the AI-generated sketch attachment on entries
 *     are all hidden. Backend (photo_routes.py, sketch_engine.py,
 *     S3 storage, db.photos collection) is untouched. Existing
 *     uploaded photos remain in storage and database; they are simply
 *     not surfaced anywhere in the UI. Pro plan no longer includes a
 *     photo-upload promise until the flag flips back to true.
 *
 * If you flip a flag, document the date and reason in this header.
 */

export const FEATURE_FLAGS = {
  PHOTOS_ENABLED: false,
};

export const PHOTOS_ENABLED = FEATURE_FLAGS.PHOTOS_ENABLED;
